
@if(!_orderTrackingService.loading$()){
    <ng-container [ngTemplateOutlet]="component_loaded"></ng-container>
}
@else(){
    <ng-container [ngTemplateOutlet]="component_loading"></ng-container>
}


    <ng-template #component_loaded>
        <div class="min-h-screen bg-gray-300 py-[150px] md:py-[110px] lg:py-[150px] px-20 ">
            <div class="grid grid-cols-1 lg:grid-cols-1 gap-[25px] mb-[25px]">
                <h3>
                    @if(!_orderTrackingService.isFormEmpty()){
                        <!-- Bienvenue sur votre suivi de commande  -->
                        {{ 'i18n.app.features.pages.order.tracking.order_tracking.div_01' | translate }} 
                        {{ _orderTrackingService.orderTracking$()?.customer?.firstName }}
                    }
                </h3>
            </div>
            
            <!-- Order Tracking -->
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-[25px] mb-[25px]">
                <div class="lg:col-span-2 h-full">
                    <corp-card [corp-content]="tp_corp_card_order_history"></corp-card>
                </div>
                <div class="lg:col-span-1 h-full">
                    <corp-card [corp-content]="tp_corp_card_order_summary"></corp-card>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #component_loading>
        <div class="min-h-screen bg-gray-300 py-[150px] md:py-[110px] lg:py-[150px] px-20 ">
            <div class="grid grid-cols-1 lg:grid-cols-1 gap-[25px] mb-[25px]">
            </div>
            
            <!-- Order Tracking -->
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-[25px] mb-[25px]">
                <div class="lg:col-span-2 h-full">
                    <corp-loading></corp-loading>
                </div>
                <div class="lg:col-span-1 h-full">
                    <corp-loading></corp-loading>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #tp_corp_card_order_summary>
        <div class="corp-card">
            <div class="corp-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between">
                    <h5 class="!mb-0">
                        
                        <!-- Order Summary  -->
                        {{ 'i18n.app.features.pages.order.tracking.order_tracking.h5_03' | translate }} 
                    </h5>
                <div 
                    class="h-10 w-10 flex items-center justify-center rounded-full text-white bg-primary-500 shadow-lg shadow-primary">
                    <span class="material-symbols-outlined text-2xl leading-none">
                        trolley
                    </span>
                </div>
            </div>
            <div class="corp-card-content">
               @if(!_orderTrackingService.isFormEmpty()){
                <div class="table-responsive overflow-x-auto">
                    <table class="w-full">
                        <thead class="text-black dark:text-white">
                            <tr>
                                <th class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md">
                                    <!--i18n: Description  -->
                                    {{ 'i18n.app.features.pages.order.tracking.order_tracking.th_01' | translate }} 
                                </th>
                                <th class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md">
                                    <!--i18n: Rate  -->
                                    {{ 'i18n.app.features.pages.order.tracking.order_tracking.th_02' | translate }} 
                                </th>
                                <th class="font-medium ltr:text-right rtl:text-left px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md">
                                    <!--i18n: Price  -->
                                    {{ 'i18n.app.features.pages.order.tracking.order_tracking.th_03' | translate }} 
                                </th>
                            </tr>
                        </thead>
                        <tbody class="text-black dark:text-white">
                                @for(currencyPurchase of _orderTrackingService.orderTracking$()?.order?.currencyPurchaseList; track currencyPurchase.id) {
                                <tr>
                                    <td class="flex items-center gap-2 text-gray-500 text-sm dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                                        <span>
                                            <!--i18n: Purchase  -->
                                            {{ 'i18n.app.features.pages.order.tracking.order_tracking.span_03' | translate }} 
                                        </span>
                                        <img class="h-5 w-5" [src]="currencyPurchase.targetCurrency?.imgPath" alt="" />
                                        <span>{{currencyPurchase.targetAmount}}</span>
                                        <span class="relative group inline-flex items-center gap-1 ml-1">
                                            <!-- Chip -->
                                            <span class="px-2 py-0.5 rounded-full text-white bg-secondary-600 dark:bg-gray-700 text-xs font-medium cursor-pointer">
                                                {{currencyPurchase.targetCurrency?.symbol}}  {{currencyPurchase.targetCurrency?.code}}
                                            </span>
                                            <!-- Tooltip -->
                                            <span class="absolute bottom-full mb-2 hidden group-hover:block 
                                                        bg-black text-white text-xs rounded px-2 py-1 whitespace-nowrap">
                                                {{currencyPurchase.targetCurrency?.label}}
                                            </span>
                                        </span>

                                    </td>
                                    <td class="text-gray-500 text-sm dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                                        {{ currencyPurchase.targetCurrency?.sellRate }}
                                    </td>
                                    <td class="text-gray-500 text-sm dark:text-gray-400 ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                                        €{{ currencyPurchase.sourceAmount }}
                                    </td>
                                </tr>
                                }
                            <tr>
                                <td colspan="2" class="text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                                    <!--i18n: Sub Total  -->
                                    {{ 'i18n.app.features.pages.order.tracking.order_tracking.td_01' | translate }} 
                                </td>
                                <td class="text-gray-500 dark:text-gray-400 ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                                    €{{ _orderTrackingService.orderTracking$()?.order?.pricingSummary?.subTotal }}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" class="text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                                    <!--i18n: Discount  -->
                                    {{ 'i18n.app.features.pages.order.tracking.order_tracking.td_02' | translate }}
                                </td>
                                <td class="text-gray-500 dark:text-gray-400 ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                                    €{{ _orderTrackingService.orderTracking$()?.order?.pricingSummary?.discount }}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" class="text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                                    <!--i18n: Service Fee  -->
                                    {{ 'i18n.app.features.pages.order.tracking.order_tracking.td_03' | translate }}
                                </td>
                                <td class="text-gray-500 dark:text-gray-400 ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                                    €{{ _orderTrackingService.orderTracking$()?.order?.pricingSummary?.serviceFee }}
                                </td>
                            </tr>
                            
                            <tr>
                                <td colspan="2" class="font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                                    <!--i18n: Total  -->
                                    {{ 'i18n.app.features.pages.order.tracking.order_tracking.td_04' | translate }}
                                </td>
                                <td class="font-medium ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                                    €{{ _orderTrackingService.orderTracking$()?.order?.pricingSummary?.total }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            }
            @else {
                <div class="flex items-center justify-center h-40 bg-gray-300 rounded-sm">
                    <h4>
                        <!--i18n: No information available  -->
                        {{ 'i18n.app.features.pages.order.tracking.order_tracking.h4_01' | translate }}
                    </h4>
                </div>
            }
            </div>
        </div>
    </ng-template>

    <ng-template #tp_corp_card_order_history>
        <div class="corp-card">
            <div class="corp-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between">
                <h5 class="!mb-0">
                    <!--h5_01 Order ID  -->
                    {{ 'i18n.app.features.pages.order.tracking.order_tracking.h5_01' | translate }}: 
                    {{ _orderTrackingService.orderTracking$()?.order?.code }}
                </h5>
                
                <div 
                    class="h-10 w-10 flex items-center justify-center rounded-full text-white bg-primary-500 shadow-lg shadow-primary">
                    <span class="material-symbols-outlined text-2xl leading-none">
                        track_changes
                    </span>
                </div>

                <!-- <div class=" mt-[15px] sm:mt-0">
                    <h5 class="!mb-0">
                        h5_02 Tracking ID  
                        {{ 'i18n.app.features.pages.order.tracking.order_tracking.h5_02' | translate }} 
                    </h5>
                </div> -->
            </div>

            <div class="corp-card-content" >
                @if(!_orderTrackingService.isFormEmpty()){

            <div class="mb-1 grid grid-cols-2 gap-0.5 items-start">
                <div class="mb-1 grid grid-cols-8 gap-0.5 items-center">
                    <span class="col-span-3 text-black">
                        <!-- span_01: Date -->
                        {{ 'i18n.app.features.pages.order.tracking.order_tracking.span_01' | translate }}:
                    </span>
                    <span class="col-span-5 text-black text-sm">
                        {{ _orderTrackingService.orderTracking$()?.order?.dateCreate | date:'dd/MM/yyyy HH:mm:ss' }}
                    </span>
                    <!-- <span  class="col-span-5"></span>    -->
                    <span  class="col-span-8 p-5"></span>
                    
                    <span class="col-span-3 text-black">
                        <!-- span_02: Your withdrawal agency -->
                        {{ 'i18n.app.features.pages.order.tracking.order_tracking.span_02' | translate }}:
                    </span>
                    <span class="col-span-5 text-black text-sm"> 
                        {{ _orderTrackingService.orderTracking$()?.pickupPoint?.place?.label }}  
                    </span>
                    <!-- <span  class="col-span-4"></span>    -->

                    <span class="col-span-3 text-black"></span>
                    <span class="col-span-5 text-black text-sm">
                        {{ _orderTrackingService.orderTracking$()?.pickupPoint?.address?.streetName }}
                        {{ _orderTrackingService.orderTracking$()?.pickupPoint?.address?.streetNumber }}
                    </span>
                    <!-- <span  class="col-span-4"></span>    -->

                    <span class="col-span-3 text-black">

                    </span>
                    <span class="col-span-5 text-black text-sm"> 
                        {{ _orderTrackingService.orderTracking$()?.pickupPoint?.address?.postalCode }}
                        {{ _orderTrackingService.orderTracking$()?.pickupPoint?.address?.city }}
                    </span>
                    <!-- <span  class="col-span-4"></span>    -->

<!-- class="block relative inline-block" -->
                    


                </div>
                        <div>
                            <img src="images/card/{{_orderTrackingService.orderTracking$()?.pickupPoint?.place?.code?.toLowerCase()}}.png" 
                                class="rounded-[5px] h-50 w-80" 
                                alt="property-image">
                            <!-- <span class="material-symbols-outlined 
                                        absolute top-0 left-0 
                                        m-2 p-1/2 
                                        bg-white rounded-sm shadow-md">
                                person_pin_circle
                            </span> -->
                        </div>
            </div>

                <div class="my-[25px] md:my-[45px] md:flex z-[1] relative justify-between">
                    <span class="block absolute bottom-0 md:bottom-auto ltr:left-[25px] ltr:md:left-0 ltr:md:right-0 rtl:right-[25px] rtl:md:right-0 rtl:md:left-0 top-[25px] -z-[1] border-t border-dashed border-primary-500 ltr:border-l ltr:md:border-l-0 rtl:border-l rtl:md:border-l-0"></span>

                    @for(historyItem of _orderTrackingService.orderTracking$()?.history; track historyItem.id) {
                        
                        @if(!historyItem.status?.isFailureState){
                            <div>
                                @if(historyItem.dateCreate==null){
                                    <div class="rounded-full text-center font-semibold text-black dark:text-white w-[50px] h-[50px] leading-[48px] bg-white dark:bg-[#0c1427] border border-dashed border-primary-500">
                                        
                                        {{ historyItem.status?.order }}
                                    </div>
                                }
                                @else {
                                    <div class="rounded-full text-center font-semibold text-white w-[50px] h-[50px] leading-[48px] bg-secondary-600 border border-dashed border-secondary-400">
                                        {{ historyItem.status?.order }}
                                    </div>
                                }
                                
                                <span class="block text-md mt-[17px] font-semibold text-black dark:text-white ltr:pl-[45px] rtl:pr-[45px] md:!p-0">
                                    {{ historyItem.status?.label }}
                                </span>
                                <span class="block mb-[15px] md:mb-0 mt-[7px] ltr:pl-[45px] rtl:pr-[45px] md:!p-0">
                                    {{ historyItem.dateCreate | date}}
                                </span>
                            </div>
                        }


                        
                        <!-- @else {
                            @if(historyItem.dateCreate){
                                <div class="rounded-full text-center font-semibold text-white w-[50px] h-[50px] leading-[48px] bg-danger-600 border border-dashed border-danger-400">
                                    {{ historyItem.status?.order }}
                                </div>
                                <span class="block text-md mt-[17px] font-semibold text-black dark:text-white ltr:pl-[45px] rtl:pr-[45px] md:!p-0">
                                    {{ historyItem.status?.label }}
                                </span>
                                <span class="block mb-[15px] md:mb-0 mt-[7px] ltr:pl-[45px] rtl:pr-[45px] md:!p-0">
                                    {{ historyItem.dateCreate | date}}
                                </span>
                            }
                        } -->
                        
                    }

                </div>
                <span class="block font-semibold text-black dark:text-white mb-[10px] last:mb-0">
                    <!--i18n: View Details  -->
                    {{ 'i18n.app.features.pages.order.tracking.order_tracking.span_04' | translate }}
                </span>

                <span class="block mb-[10px] last:mb-0">
                        <div class="grid grid-cols-[1fr_2fr_6fr]"> 
                @for(historyItem of _orderTrackingService.orderTracking$()?.history!.slice().reverse(); track historyItem.id) {
                    
                        @if(historyItem.dateCreate != null) {
                            
                            @if(!historyItem?.status?.isFailureState) {
                                <i class="material-symbols-outlined !text-[22px] md:!text-xl">
                                    task_alt
                                </i>
                                <div class="text-secondary-600"> {{ historyItem.dateCreate | date:'dd/MM/yyyy HH:mm:ss' }}</div> 
                                <span class="text-black dark:text-white">{{ historyItem.status?.labelLong }}</span>
                            }
                            @else {
                                <i class="material-symbols-outlined !text-[22px] text-danger-600 md:!text-xl">
                                    error
                                </i>
                                <div class="text-danger-600"> {{ historyItem.dateCreate | date:'dd/MM/yyyy HH:mm:ss' }}</div> 
                               
                                <span class="text-black dark:text-white">{{ historyItem.status?.labelLong }}</span>
                            }
                            
                        }
                      
                }
                   </div>
                    </span>
            }
            @else {
                <div class="flex items-center justify-center h-40 bg-gray-300 rounded-sm">
                    <h4>
                        <!--i18n: No information available  -->
                        {{ 'i18n.app.features.pages.order.tracking.order_tracking.h4_02' | translate }}
                    </h4>
                </div>
            }
            </div>
        </div>
                    
    </ng-template>

    

